export default __webpack_public_path__ + "static/media/landingpage.abdd14e2.jpg";